import { taskApi } from 'app/services/api';
import _ from 'lodash';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { updatePipelineEntityV2Action } from 'store/loanPipelines/actions';

import { selectApplicationIdFromDeal } from '../selectors';

export const TASKS_ACTION_TYPE = createNamedActions('tasks', {
  GET_TASKS_BY_LOAN_ID: 'GET_TASKS_BY_LOAN_ID',
  ADD_TASK: 'ADD_TASK',
  EDIT_TASK: 'EDIT_TASK',
  APPROVE_TASK: 'APPROVE_TASK',
  REJECT_TASK: 'REJECT_TASK',
  DELETE_TASKS: 'DELETE_TASKS',
});

const tasks = new schema.Entity('tasks', {}, { idAttribute: 'taskId' });

export const getLoanApplicationTasksAction = catchAsyncActionError(
  ({ applicationId, signal } = {}) =>
    async (dispatch, getState) => {
      const resolvedApplicationId = applicationId ?? selectApplicationIdFromDeal(getState());

      if (_.isNil(resolvedApplicationId)) {
        return null;
      }

      const { data } = await taskApi.getLoanTasks({ applicationId: resolvedApplicationId, signal });

      return dispatch({
        type: TASKS_ACTION_TYPE.GET_TASKS_BY_LOAN_ID,
        payload: normalize(data, [tasks]).entities.tasks,
      });
    },
);

export const approveTaskAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await taskApi.approveTask(params);

  return dispatch({
    type: TASKS_ACTION_TYPE.APPROVE_TASK,
    payload: data,
  });
});

export const approveScheduleClosingTaskAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await taskApi.approveScheduleClosingTask(params);

  return dispatch({
    type: TASKS_ACTION_TYPE.APPROVE_TASK,
    payload: data,
  });
});

export const rejectTaskAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await taskApi.rejectTask(params);

  return dispatch({
    type: TASKS_ACTION_TYPE.REJECT_TASK,
    payload: normalize([data], [tasks]).entities.tasks,
  });
});

// The thread view refetches its own history after a successful post, so no store write is needed —
// this only surfaces errors via catchAsyncActionError and returns the created record.
export const postTaskMessageAction = catchAsyncActionError(params => async () => {
  const { data } = await taskApi.postTaskMessage(params);

  return data;
});

export const addTaskAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await taskApi.createTask(params);

  return dispatch({
    type: TASKS_ACTION_TYPE.ADD_TASK,
    payload: data,
  });
});

export const editTaskAction = (data, params) => ({
  type: TASKS_ACTION_TYPE.EDIT_TASK,
  payload: data,
  meta: params,
});

export const updateTaskAsyncAction = catchAsyncActionError(params => async dispatch => {
  const { pipelineId } = params;
  const { data } = await (pipelineId
    ? taskApi.updatePipelineTask(params)
    : taskApi.updateTask(params));

  const { pipelineEntryData } = data;

  if (pipelineEntryData) {
    dispatch(updatePipelineEntityV2Action(pipelineEntryData.data));
  }

  return dispatch(editTaskAction(pipelineId ? data.task : data, params));
});
